import { BulkActionButtonComponent } from 'commons/components/bulk-action-button/bulk-action-button.component';
import { useTranslation } from 'core/i18n';

export interface BulkDeleteCustomAlarmsComponentProps {
    onClick: VoidFunction;
}

export const BulkDeleteCustomAlarmsComponent: React.FC<BulkDeleteCustomAlarmsComponentProps> = (props) => {
    const { t } = useTranslation();
    const { onClick } = props;

    return (
        <BulkActionButtonComponent
            text={t('settings.devices.custom-alarms.actions.delete')}
            iconName="delete"
            onClick={onClick}
        />
    );
};
